import React, { memo, useCallback, useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { useAppContext } from "@app/providers/app"
import { FormButton } from "@app/components/Form/FormButton"

import type { ProductVariantProps } from "@root/types/global"

type Props = {
  handleErrors?: () => void
  handleToggle: () => void
  isLoading?: boolean
  variant?: ProductVariantProps
}

export const ProductGiftcardToggle: React.FC<Props> = memo(({ handleErrors, handleToggle, isLoading, variant }) => {
  const { giftcard } = useStaticQuery<GatsbyTypes.ProductGiftcardToggleQuery>(graphql`
    query ProductGiftcardToggle {
      giftcard: sanityPageGiftcard {
        additionalGiftcardButton
      }
    }
  `)
  const { activeVariant } = useAppContext()

  const currentVariant = useMemo(() => variant || activeVariant, [activeVariant, variant])

  const handleClick = useCallback(
    () => (currentVariant?.id ? handleToggle() : !isLoading && handleErrors && handleErrors()),
    [currentVariant?.id, isLoading, handleErrors, handleToggle]
  )

  return (
    <FormButton
      onClick={handleClick}
      size="md"
      title={giftcard?.additionalGiftcardButton}
      aria-label={giftcard?.additionalGiftcardButton}
      variant="pdpAddToCart"
      w="full"
    >
      {giftcard?.additionalGiftcardButton}
    </FormButton>
  )
})
